import { iDataGridDisplayOptions } from 'fulogics-ui-web/dist/layout/dx/DataGrid/DataGrid';
import propsStore from 'fulogics-ui-web/dist/layout/inspector/propsStore';
import { ForwardStepTypeDisplayOptions } from '../forward-step-type/ForwardStepType';
import { ReturnStepTypeDisplayOptions } from '../return-step-type/ReturnStepType';

export const orderDetailsForwardGridId = 'OrderDetails.orderStepsForwardGrid';
const orderDetailsForwardGridOptions: iDataGridDisplayOptions = {
    id: orderDetailsForwardGridId,
    columnAutoWidth: true,
    showBorders: false,
    showColumnLines: false,
    columns: [
        {
            dataField: 'id',
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexCircleColumn',
            sortOrder: 'asc',
            allowSorting: false,
        },
        {
            dataField: 'location',
            caption: 't~OrderForward:column.location',
            cellTemplate: 'RouteLocationModelMultiLineColumn',
            allowSorting: false,
        },
        {
            dataField: 'plannedStartDate',
            caption: 't~OrderForward:column.plannedStartDate',
            width: '200px',
            dataType: 'datetime',
            allowSorting: false,
        },
        {
            dataField: 'type',
            caption: 't~OrderForward:column.type',
            cellTemplate: 'ForwardStepTypeColumn',
            allowSorting: false,
        },
    ],
};

propsStore.insert(orderDetailsForwardGridOptions);

export const orderDetailsReturnGridId = 'OrderDetails.orderStepsReturnGrid';
const orderDetailsReturnGridOptions: iDataGridDisplayOptions = {
    id: orderDetailsReturnGridId,
    columnAutoWidth: true,
    showBorders: false,
    showColumnLines: false,
    columns: [
        {
            dataField: 'id',
            caption: '#',
            width: '50px',
            cellTemplate: 'RowIndexCircleColumn',
            sortOrder: 'asc',
            allowSorting: false,
        },
        {
            dataField: 'location',
            caption: 't~OrderReturn:column.location',
            cellTemplate: 'RouteLocationModelMultiLineColumn',
            allowSorting: false,
        },
        {
            dataField: 'plannedStartDate',
            caption: 't~OrderReturn:column.plannedStartDate',
            width: '200px',
            dataType: 'datetime',
            allowSorting: false,
        },
        {
            dataField: 'type',
            caption: 't~OrderReturn:column.type',
            cellTemplate: 'ReturnStepTypeColumn',
            allowSorting: false,
        },
    ],
};

propsStore.insert(orderDetailsReturnGridOptions);

export const orderDetailsOrderStepsForwardGridColumnTypeId =
    'OrderDetails.orderStepsForwardGrid.column.type';
const orderDetailsOrderStepsForwardGridColumnTypeOptions: ForwardStepTypeDisplayOptions = {
    id: orderDetailsOrderStepsForwardGridColumnTypeId,
    showPayload: true,
    // @ts-ignore
    onPayloadClick: 'v~handleForwardStepTypeClick',
};
propsStore.insert(orderDetailsOrderStepsForwardGridColumnTypeOptions);

export const orderDetailsOrderStepsReturnGridColumnTypeId =
    'OrderDetails.orderStepsReturnGrid.column.type';
const orderDetailsOrderStepsReturnGridColumnTypeOptions: ReturnStepTypeDisplayOptions = {
    id: orderDetailsOrderStepsReturnGridColumnTypeId,
    showPayload: true,
    // @ts-ignore
    onPayloadClick: 'v~handleReturnStepTypeClick',
};
propsStore.insert(orderDetailsOrderStepsReturnGridColumnTypeOptions);
